$(document).ready(function(){
    'use strict';

    var body = $('body');

    // body.on('click','#change-password', function () {
    //    //modalChangePass.modal('show');
    // });
    //
    // var modalChangePass = $('#fos-change-password');
    // modalChangePass.on('show.bs.modal', function () {
    //
    //     var container = $('#fos-change-password-content');
    //     var url = Routing.generate('fos_user_change_password');
    //
    //     $.ajax({
    //         url: url,
    //         method: 'get',
    //         beforeSend: function () {
    //             container.html('' +
    //                     '<div class="loader-wrapper">' +
    //                         '<div class="loader-container">' +
    //                             '<div class="ball-grid-pulse text-xs-center loader-danger "><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>' +
    //                         '</div>' +
    //                     '</div>'
    //                 );
    //         },
    //         success: function(data) {
    //             container.html(data);
    //             validateResetPasswordForm(container);
    //         },
    //         error: function() {
    //             container.html('Blad');
    //         }
    //     });
    //
    // });
    //
    // // var l = Ladda.create(document.querySelector('.ladda-button'));
    // // l.start();
    //
    //
    // function validateResetPasswordForm(container) {
    //
    //     var l = Ladda.create(document.querySelector('.ladda-button'));
    //     if($("form#fos_user_change_password_form").attr("novalidate") != undefined){
    //
    //         $("input,select,textarea").not("[type=submit]").jqBootstrapValidation({
    //
    //             submitSuccess: function ($form, event) {
    //
    //                 $.ajax({
    //                     type: 'POST',
    //                     url: $form.attr('action'),
    //                     data: $form.serialize(),
    //                     beforeSend: function () {
    //                         l.start();
    //                     },
    //                     success: function(data){
    //                         l.stop();
    //                         container.html(data);
    //                         validateResetPasswordForm(container);
    //                     }
    //                 });
    //
    //                 event.preventDefault();
    //             }
    //
    //         });
    //
    //     }
    //
    // }




});
